module.exports = __webpack_public_path__ + "img/packaging.ed90cddc.svg";